import {
  Http
} from '@/model/Http.js'
import { getToken, getUserUUID } from '@/utils/auth'
export default class set extends Http {
  //推广设置-查询
  getPromotionSet(data) {
    const url = 'api/params-push/query'
    return this.postAjax(url, {
      ...data
    })
  }

  //推广设置-修改
  savePromotionSet(data) {
    const url = 'api/params-push/update'
    return this.postAjax(url, {
      ...data
    })
  }

  //提现设置-查询
  getWithdrawSet(data) {
    const url = 'api/params-withdraw/query'
    return this.postAjax(url, {
      ...data
    })
  }

  //提现设置-修改
  saveWithdrawSet(data) {
    const url = 'api/params-withdraw/update'
    return this.postAjax(url, {
      ...data
    })
  }
  // 获取选中的系统海报 此接口请求的id 为platformUuid
  getChoosedPoster(data){
    const url ='api/params-poster/queryList'
    return this.postAjax(url, {
       ...data
    })
  }
  setChoosePoster(data){
    const url = 'api/params-poster/update'
    return this.postAjax(url, {
       ...data
    })
  }
  uoloadFile(data){
      const url = 'api/params-withdraw/upload-local'
      return this.$axios.post(`${this.host}${url}`, data ,{
          headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "x-token": getToken(),
              "uuid": getUserUUID()
          }
      })
  }
  // 获取系统海报
  getPosterList(data){
    const url = 'api/params-poster/query'
    return this.postAjax(url, {
       ...data
    })
  }

  // 上传自定义海报
  uoloadDefinePoster(data){
    const url = 'api/params-poster/upload-self-poster'
    return this.$axios.post(`${this.host}${url}`, data ,{
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-token": getToken(),
        "uuid": getUserUUID()
      }
    })
  }

  // 获取自定义海报
  getDefinePosterList(data){
    const url = 'api/params-poster/query-self-poster'
    return this.postAjax(url, {
      ...data
    })
  }

  // 删除自定义海报
  delDefinePoster(data){
    const url ='api/params-poster/delete-self-poster'
    return this.postAjax(url, {
      ...data
    })
  }

  // 获取已启用海报
  getCurPoster(data){
    const url ='api/params-poster/query-start-poster'
    return this.postAjax(url, {
      ...data
    })
  }

  /**
   * 提交自动报价设置
   * @param data
   * @returns {*}
   */
   saveSwitch(data){
     const url = '/api/params-withdraw/update-switch'
    return this.postAjax(url,{
      ...data
    })
  }
}




// WEBPACK FOOTER //
// ./src/javaApi/set.js